import React, {FC, memo} from 'react';

import {urlPrefixed} from '../../../config';
import {isInIframe} from '../../../setup';
import WBLogo from '../../WBLogo';
import NavLeftDefault from './NavLeftDefault';
import NavLeftInIframe from './NavLeftInIframe';

const NavLeftComp: FC = () => {
  return (
    <div className="nav-left-container">
      <WBLogo
        onClick={(e: any) => {
          window.analytics?.track('Home clicked');
          if (isInIframe()) {
            e.preventDefault();
            window.open(urlPrefixed());
          }
        }}
      />
      {isInIframe() ? <NavLeftInIframe /> : <NavLeftDefault />}
    </div>
  );
};

const NavLeft = memo(NavLeftComp);

export default NavLeft;
